import React from "react";
import SunEditor from "suneditor-react";

const Editor = ({ onChange, content, height = 300, placeholder }) => {
    return (
        <SunEditor
            setContents={content}
            setOptions={{
                height: height,
                buttonList: [
                    ["undo", "redo"],
                    ["font", "fontSize", "formatBlock"],
                    ["paragraphStyle", "blockquote"],
                    ["bold", "underline", "italic"],
                    ["fontColor", "hiliteColor", "textStyle"],
                    ["outdent", "indent"],
                    ["align", "horizontalRule", "list"],
                    ["table"],
                    ["print"],
                    ["fullScreen"],
                ],
                colorList: [
                    ["#ccc", "#dedede", "OrangeRed", "Orange", "RoyalBlue", "SaddleBrown"],
                    ["SlateGray", "BurlyWood", "DeepPink", "FireBrick", "Gold", "SeaGreen"],
                    ["hsl(30, 75%, 60%)", "hsl(0, 75%, 60%)", "hsl(60, 75%, 60%)", "hsl(90, 75%, 60%)", "hsl(120, 75%, 60%)", "aliceblue"],
                ],
            }}
            placeholder={placeholder}
            onChange={(_content) => onChange(_content)}
        />
    );
};
export default Editor;
